'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NEW_UTK = exports.NEW_UTK = ['metadata', 'newMessagesUtk'];
var NEW_VID = exports.NEW_VID = ['metadata', 'newVid'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/contact-association-metadata/constants/keyPaths.js
// module id = 809
// module chunks = 2 3